import { PaymentAssignments } from '../object-actions/types/types';

export function getPaymentCreatedAt(assignment: PaymentAssignments): string | null {
    const createdAt = assignment.payment?.entity?.created_at;
    return createdAt ?? null;
}

export function formatPaymentDate(iso: string | null | undefined): string | null {
    if (!iso) return null;
    const date = new Date(iso);
    if (Number.isNaN(date.getTime())) return null;
    return date.toLocaleDateString(undefined, {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
    });
}

export function formatAssignmentPaymentDate(assignment: PaymentAssignments): string | null {
    return formatPaymentDate(getPaymentCreatedAt(assignment));
}

export function getPaymentPayerDisplayName(assignment: PaymentAssignments): string | null {
    const author = assignment.payment?.entity?.author;
    if (!author) return null;
    const name = `${author.first_name ?? ''} ${author.last_name ?? ''}`.trim();
    return name || author.username || null;
}

export function formatAssignmentPaymentLabel(assignment: PaymentAssignments): string {
    const date = formatAssignmentPaymentDate(assignment);
    const payer = getPaymentPayerDisplayName(assignment);
    const parts = [date, payer].filter(Boolean);
    if (parts.length > 0) {
        parts.unshift('Paid')
        return parts.join(' · ');
    }
    return `Assignment #${assignment.id}`;
}
